
import { Component, Vue } from 'vue-property-decorator'
import { QnaVO } from '@/views/biz/product/vo/qna.vo'
import { MstContentsVO } from './vo/mypage.vo'
import axios from 'axios'

@Component
export default class Faq extends Vue{

  qnaList: Array<MstContentsVO> = [] as Array<MstContentsVO>;
  currentTabIdx ="044003";

    // textarea 개행 문자 변경. \n -> <br>
  getConvertedQnaText(text: string) {
    return text.replace(/\n/g, "<br>");
  }
  
  // 중복 제거
  get groupByContentCds() {
    return this.qnaList.filter((item, i) => {
      return this.qnaList.findIndex((item2) => {
        return item.ctntGroupCd === item2.ctntGroupCd
      }) === i;
    });
  }

  // 그룹코드와 일치하는 QnA가져오기
  filterByContentCd(): Array<MstContentsVO> {
    return this.qnaList.filter(item => item.ctntGroupCd == this.currentTabIdx);
  }

  btnMore(ctntCd: number) {
    this.qnaList.forEach((item: MstContentsVO, i: number) => {
      if(ctntCd == item.ctntCd) {
        item.isExpand = !item.isExpand;
      } else {
        item.isExpand = false;
      }
      this.$set(this.qnaList, i, item);
    });
  }

  created() {
    // QnA
    axios.get(`/common/contents/043002`)
    .then(r => {
      this.qnaList = r.data;
    }) 
  }

}
